export default __webpack_public_path__ + "static/media/area-warnings.6ae407a5.svg";